export const Serve = [
    {
    image: '/image/test2.jpg',
    rating: 3,
    size: '16/20',
        price: '30,000',
        naira: '/image/naira.png',
        share:'/image/whatsapp.png'
        
},
    {
    image: '/image/babyframe.jpg',
    rating: 5,
    size: '36/48',
        price: '100,000',
        naira: '/image/naira.png',
        share:'/image/whatsapp.png'
    
    
},
    {
    image: '/image/mcedo.jpg',
    rating: 4.5,
    size: '16/20',
        price: '40,000',
        naira: '/image/naira.png',
        share:'/image/whatsapp.png'
        
    
},
    {
    image: '/image/girl.jpg',
    rating: 3,
    size: '12/15',
        price: '25,000',
        naira:'/image/naira.png',
        share:'/image/whatsapp.png'
        
},
]
